import React, { useEffect } from 'react';

const TrustpilotWidget: React.FC<{height?: string, width?: string}> = ({height, width}): JSX.Element => {

    useEffect(() => {
        const script = document.createElement('script');

        script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
        script.defer = true;

        document.body.appendChild(script);

        script.onload = () => {
            (window as any).Trustpilot.Modules.WidgetManagement.initialize();
        };

        return () => {
            document.body.removeChild(script);
        }
    }, []);

    return (
        <>
            <div
                id="trustbox"
                className="trustpilot-widget"
                data-locale="pt-BR"
                data-template-id="5419b6ffb0d04a076446a9af"
                data-businessunit-id="5aa6c739a707cb00017177eb"
                data-style-height={height}
                data-style-width={width}
                data-theme="light"
            >
                <a
                    href="https://br.trustpilot.com/review/bizcapital.com.br"
                    target="_blank"
                    rel="noopener"
                >
                    Trustpilot
                </a>
            </div>
        </>
    );
};

export default TrustpilotWidget;
